import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehhlazq46a: FaireProductEntity = {
  token: "p_ehhlazq46a",
  type: "product",
  name: "Helium 30 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ae03ec3d9ef0ab06a079267e084598b18a24f777810c52a9d69e7ebc7bac17ec.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/328b96b8c08a485aba22c531c4089303378e6a589c2c3f914336b51b68b8b5b6.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:37.764Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
